/**
 * Geeft elk <strong> of <b> dat met "Vibe check" begint de klasse vibe-check (rood handschrift, zie dw-home.css).
 * Ook voor producten die later worden geladen (filters, volgende pagina).
 */
(function () {
  function tag(root) {
    root.querySelectorAll('strong,b').forEach(function (e) {
      if (!e.classList.contains('vibe-check') && /^\s*vibe check/i.test(e.textContent) && e.children.length === 0) e.classList.add('vibe-check');
    });
  }
  tag(document);
  new MutationObserver(function (m) {
    m.forEach(function (r) {
      r.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) tag(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
